import { useState } from 'react';
import './UpdateBanner.css';
import { HiOutlineArrowPath, HiXMark } from 'react-icons/hi2';

interface UpdateBannerProps {
  visible: boolean;
}

function UpdateBanner({ visible }: UpdateBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (!visible || dismissed) return null;

  return (
    <div className="update-banner">
      <button className="update-banner-close" onClick={() => setDismissed(true)}>
        <HiXMark />
      </button>
      <div className="update-banner-title">New Update Available</div>
      <p className="update-banner-desc">
        We've shipped new features and improvements. Refresh to get the latest version.
      </p>
      <button className="update-banner-btn" onClick={() => window.location.reload()}>
        <HiOutlineArrowPath />
        Refresh Now
      </button>
    </div>
  );
}

export default UpdateBanner;
